/**
 * @generated SignedSource<<63e4b4b5654d044e095111904b4801ac>>
 * @relayHash 9ab71c77a538002c46c237ae928d5f03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa36de1317d82cca9120f0212240884de55487b414401daec208a504366bd2fb

import type { ConcreteRequest } from 'relay-runtime';
export type use3PAuthenticationQuery$variables = {
  cloudId: string;
};
export type use3PAuthenticationQuery$data = {
  readonly search: {
    readonly configuration: {
      readonly thirdPartyProducts: ReadonlyArray<{
        readonly isUserOAuthed: boolean;
        readonly name: string;
        readonly outboundAuthUrl: string;
        readonly providerId: string | null;
      }>;
    } | null;
  } | null;
};
export type use3PAuthenticationQuery = {
  response: use3PAuthenticationQuery$data;
  variables: use3PAuthenticationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "SearchQueryAPI",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "SearchGraphQLConfigurationResponse",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "concreteType": "SearchThirdPartyMetadata",
            "kind": "LinkedField",
            "name": "thirdPartyProducts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "isUserOAuthed"
              },
              {
                "kind": "ScalarField",
                "name": "outboundAuthUrl"
              },
              {
                "kind": "ScalarField",
                "name": "providerId"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "use3PAuthenticationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "use3PAuthenticationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ab71c77a538002c46c237ae928d5f03",
    "id": "aa36de1317d82cca9120f0212240884de55487b414401daec208a504366bd2fb",
    "metadata": {},
    "name": "use3PAuthenticationQuery",
    "operationKind": "query",
    "text": "query use3PAuthenticationQuery($cloudId:ID!){search{configuration(cloudId:$cloudId){thirdPartyProducts{name,isUserOAuthed,outboundAuthUrl,providerId}}}}"
  }
};
})();

(node as any).hash = "395781fb487938898a5cb0d0541a783e";

export default node;
